/* 
*  SLOTS
*  - default 
*  - collapse-btn 
*  - header-dx 
*  - description 
*
*  PROPS
*  -collapsed
*  -content_h100
*  -h_fit
*  -title
*/

<template>
   <div
      class="dashboard-card"
      :class="{
         'h-fit': h_fit || $slots['collapse-btn'],
         'dashboard-card__disabled': disabled,
         'dashboard-card__closed': collapsed,
      }"
   >  
      <!-- HEADER -->
      <div
         v-if="$slots['header-dx'] || $slots['collapse-btn']"
         class="dashboard-card--header"
         :class="{
            'dashboard-card--header__no-content': !$slots['default']}
         "
      >
         {{title}}

         <div
            v-if="$slots['header-dx'] || $slots['collapse-btn']"
            class="flex justify-between align-center gap-1"
            style="flex: inherit"
         >

            <!-- SLOT DX -->
            <div v-if="$slots['header-dx']">
               <slot name="header-dx"></slot>
            </div>

            <!-- <div v-if="$slots['header-dx'] && $slots['collapse-btn']">|</div> -->

            <!-- SLOT COLLAPSE BTN -->
            <a
               v-if="$slots['collapse-btn']"
               class="trigger-collapse"
               data-bs-toggle="collapse"
               :data-bs-target="'#cardCollapse' + component_id"
               aria-expanded="true"
               :aria-controls="'cardCollapse' + component_id"
               @click="collapsed = !collapsed"
            >
               <slot name="collapse-btn"></slot>
            </a>
         </div>

      </div>

      <!-- DESCRIPTION -->
      <div
         v-if="$slots['description']"
         class="dashboard-card--description"
      >
         <slot name="description"></slot>
      </div>

      <!-- MAIN -->
      <div
         v-if="$slots['default']"
         class="dashboard-card--container"
         :class="{
            'grow': content_h100,
         }"
      >  
         <div
            :id="'cardCollapse' + component_id"
            class="collapse collapse-card"
            :class="{
               'h-[100%]': !$slots['collapse-btn'],
               'show': !collapsed,
            }"
            :aria-labelledby="'heading' + component_id"
         >
            <div>
               <slot></slot>
            </div>
         </div>
      </div>

   </div>
</template>

<script>
export default {
   props: {
      disabled: {
         type: Boolean,
         default: false
      },
      // collapsed: {
      //    type: Boolean,
      //    default: false
      // },
      content_h100: { type: Boolean },
      h_fit: { type: Boolean },
      title: { type: String },
   },
   data() {
      return {
         collapsed: false
      }
   },
   computed: {
      component_id() {
         return this._uid
      }
   },
};
</script>

<style lang="scss" scoped>
/*  */
.collapse-card {
   &.show{
      visibility: visible;
   }
}

</style>
